import React from "react";

// Components
import AuthFooter from "~/common/components/AuthFooter";

// Assetes
import logo from "~/assets/img/logo.svg";
import { Trans, useTranslation } from "react-i18next";

const ContentSide = () => {
	const { t } = useTranslation();
	const url = "https://startup.gitbal.io/";
	return (
		<div className="content-side">
			<h1 className="logo">
				<img
					src={logo}
					alt={t("layouts.AuthenticationLayout.logo")}
					onClick={() => window.open(url)}
				/>
			</h1>
			<div className="login-content-wrap">
				<div className="login-content">
					<p>
						<Trans
							i18nKey="layouts.AuthenticationLayout.heading"
							components={[<i />]}
						/>
					</p>
					<p>{t("layouts.AuthenticationLayout.subHeading")}</p>
					<p>
						{t("layouts.AuthenticationLayout.content1")} <br />
						{t("layouts.AuthenticationLayout.content2")} <br />
						{t("layouts.AuthenticationLayout.content3")}
					</p>
				</div>
			</div>
		</div>
	);
};

const AuthenticationLayout = ({ contentSide, children, PATH }) => {
	return (
		<main className={`l__onePage p__` + PATH}>
			<div className="l__onePageContainer">
				<div className="c__card">
					{contentSide && <ContentSide />}
					<div className="form-side">{children}</div>
				</div>
			</div>
			<AuthFooter />
		</main>
	);
};

export default AuthenticationLayout;
